var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLinkedin = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 17.0357V9.96429C14.4 9.96429 14.0143 8.48571 12.6 8.55C11.1857 8.61429 10.7357 8.83929 10.0929 9.61071V17.0357H6.46071V5.81786H10.0607V7.45714C10.0607 7.45714 11.2179 5.175 13.6607 5.33571C15.8786 5.49643 17.55 6.84643 17.9036 9.80357H18V17.0357H14.4ZM2.15357 4.37143C0.964286 4.37143 0 3.40714 0 2.18571C0 0.996429 0.964286 0 2.15357 0C3.34286 0 4.30714 0.964286 4.30714 2.18571C4.30714 3.375 3.34286 4.37143 2.15357 4.37143ZM3.95357 17.0357H0.353572V5.81786H3.95357V17.0357Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLinkedin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/linkedin.ad71d37804502ed65377e1a92e95eb04.svg";